import { createBrowserRouter } from "react-router-dom";
import LoginRoutes from "./LoginRoutes";
import HomeRoutes from "./HomeRoutes";
import DashboardRoutes from "./DashboardRoutes";

const router = createBrowserRouter(
  [
    // {
    //   path: "/website",
    //   children: [LoginRoutes, HomeRoutes, DashboardRoutes],
    // },
    LoginRoutes,
    HomeRoutes,
    DashboardRoutes,
    // MsgsRoutes,
  ],
  {
    basename: "/",
  }
);

export default router;
